// extracted by css-extract-rspack-plugin
export default {"root":"Ageio","content":"VPaPu","noWrap":"K83G7","clickable":"O44cq","pill":"XSomb"};